import { forwardRef, type InputHTMLAttributes, type ReactNode, type TextareaHTMLAttributes } from "react";
import { cx } from "./cx";

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  size?: "sm";
  /** ID、号码、金额、MCC/MNC 用等宽。 */
  mono?: boolean;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ size, mono, invalid, className, ...rest }, ref) {
  return <input ref={ref} className={cx("ax-input", size === "sm" && "ax-input-sm", mono && "ax-input-mono", className)} aria-invalid={invalid || undefined} {...rest} />;
});

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> { invalid?: boolean }
export function Textarea({ invalid, className, ...rest }: TextareaProps) {
  return <textarea className={cx("ax-input", className)} aria-invalid={invalid || undefined} {...rest} />;
}

/** 输入框加后缀，例如金额加币种。 */
export function InputGroup({ children, addon }: { children: ReactNode; addon: ReactNode }) {
  return (
    <div className="ax-input-group">
      {children}
      <span className="ax-input-addon">{addon}</span>
    </div>
  );
}
